<script>

/*____________ Components ____________*/
import Krpano from './Krpano.svelte'

import Logo from "./Logo.svelte";
import HamburgerMenu from "./HamburgerMenu.svelte";

import NextScene from "./NextScene.svelte";
import PrevScene from "./PrevScene.svelte";

import WatermarkLogo from "./WatermarkLogo.svelte";
import ThumbsGrid from "./ThumbsGrid.svelte";

import Video from './Video.svelte'
let video;

/*____________ Popups ____________*/
import Popup from './Popup.svelte';

import PopupGallery from './PopupGallery.svelte';
let visibleGallery = false;

import { getContext } from 'svelte';
import { fade, fly } from 'svelte/transition';

const { open } = getContext('simple-modal');

function parseContent(content){
    return content
        .replaceAll('[', '<')
        .replaceAll(']', '>')
}

function openHotspotInfo(popupContent){
    // if hotspotName was passed instead of {object}
    //      create {popupContent} object from hotspot attributes
    if(typeof popupContent === 'string'){
        let hotspotName = popupContent;
        popupContent = getHotspotContent(hotspotName);
        new PopupGallery({ 
            target: document.getElementById('gallery'), 
            props: {...popupContent}
        })
    }
}


/*____________ Krpano Events ____________*/
addEventListener('krpano:infoclick', (e)=>{  
    openHotspotInfo(e.detail.hotspot)
});

addEventListener('krpano:videoclick', (e)=>{
    video = e.detail.video;
    console.log(e);
});

// /*____________ Methods ____________*/
// function getCurrentSceneInfoHotspot(){
//     let sceneName = window.CC.krpano.get('xml.scene');
//     let scene = window.CC.krpano.get(`scene[${sceneName}]`);
//     return scene.info ? scene.info : false           
// }

// function openHotspotInfo(hs){
//     let content = getHotspotContent(hs)
//     changeContent(content);
//     openSidebar();
// }

// function changeContent(infoContent){
//     if(typeof infoContent === 'string'){
//         let  hotspotName = infoContent;
//         infoContent = getHotspotContent(hotspotName);
//     }

//     title = infoContent.title;
//     content = infoContent.content;
//     image = infoContent.image;
//     video = infoContent.video;
//     gallery = infoContent.gallery;
//     customHeader = infoContent.header;
//     infoname = infoContent.name
// }



// // parses krpano html content
// function parseContent(content){
//     return content
//         .replaceAll('[', '<')
//         .replaceAll(']', '>')
// }

// // gets content from krpano hotspot
function getHotspotContent(hotspotName){
    let hotspot = window.CC.krpano.get('hotspot['+hotspotName+']');
    let galleryName = hotspot.popup_gallery;
    let hotspotGallery;

    if(galleryName){
        let galleryArr = window.CC.krpano.get('gallery['+galleryName+']').img.getArray()
        hotspotGallery = galleryArr.map((item)=>{
            return item.url.replace('%SWFPATH%', '.');
        });
    }

    let title = parseContent(hotspot.popup_title);

    let text;
    if (hotspot.popup_text) {
        text = parseContent(hotspot.popup_text);
    } else {
        text = null;
    }

    return {
        name: hotspot.name,
        title: title,
        image: hotspot.popup_image,
        gallery: hotspotGallery,
        // header: parseContent(hotspot.header),
        content: text,
    }
}

// function dispatchVideo(e){
//     if(video){
//         dispatch('loadvideo', { video: video });
//     }
// }

function showHotspots(){
    window.CC.krpano.call('show_hotspots');
}

function hideHotspots(){
    window.CC.krpano.call('hide_hotspots');
}

function nextScene(){
    window.CC.krpano.call('nextscene_loop(+1)')
}

function prevScene(){
    window.CC.krpano.call('nextscene_loop(-1)')
}

let scenes = [];

import UA from 'ua-parser-js';
const ua = new UA();
let isMobile = ua.getResult().device['type'] == 'mobile';

import SceneButton from './SceneButton.svelte';

const websiteUrl = 'https://cecbr.com/'
</script>

<!-- /*____________ Markup ____________*/ -->

<div id="gallery"></div>

<Video bind:src={video} />

<HamburgerMenu 
    color="rgba(0, 0, 0, 0.8)"
    websiteUrl={websiteUrl}
    requestInfoUrl={''}
/>

<Logo image={'./images/logo.png'} width={175} linkto={websiteUrl} />
<WatermarkLogo/>

{#if !isMobile}
    <SceneButton scene="scene_CECBR_Main_Aerial_Grey" text="Blue Ridge Main" x="30" y="130" bgColor="rgba(0, 81, 156, 0.88)" bgColor2="rgba(0, 100, 194, 0.88)" hoverBgColor="rgba(0, 81, 156, 0.88)"/>
    <SceneButton scene="scene_CECBR_Basketball_Aerial" text="Equinunk Main" x="30" y="190" bgColor="rgba(238, 21, 31, 0.88)" bgColor2="rgba(255, 22, 22, 0.88)" hoverBgColor="rgba(238, 21, 31, 0.88)"/>

    <NextScene nextScene={nextScene}/>
    <PrevScene prevScene={prevScene}/>
{/if}

<ThumbsGrid prevScene={prevScene} nextScene={nextScene} title="CECBR Tour"/>
<Krpano xml='tour.xml' />

<!-- /*____________ CSS ____________*/ -->
<style>
:global(:root){
    --primary-color: #000;
    --primary-color-rgb: 0,0,0;
    --thumb-grid-color: #000;
    --thumb-grid-color-rgb: 0, 0, 0;
    --secondary-color: rgba(0,0,0,0.8);
}

:global(.clicktext){
    font-weight: 900;
    font-size: 14px;
    text-decoration: underline;
}
</style>
